import {
  dataInputsFeatures,
  dataInputsLanguages
} from 'react-scale/components/pages/rapid/content';

import Languages from 'react-scale/components/pages/rapid/data-inputs/languages';
import AnnotationTypes from 'react-scale/components/pages/rapid/data-inputs/annotation-types';

const DataInputs = ({ dataLanguages, sensorFusion }) => (
  <div>
    <AnnotationTypes dataInputsFeatures={dataInputsFeatures} sensorFusion={sensorFusion} />
    {dataLanguages && <Languages dataInputsLanguages={dataInputsLanguages} />}
  </div>
);

DataInputs.defaultProps = {
  dataLanguages: true,
  sensorFusion: true
};

export default DataInputs;
